<template>
  <v-card :style="{height: itemHeight + 'px'}"
          max-width="270px"
          ref="card"
          v-resize="calculateTitleWidth">
    <v-img v-if="item.videoList.screenshot" :src="require('@/assets/academy/videos/' + item.videoList.screenshot)"
           contain/>

    <v-card-subtitle class="pb-2">
      <fin-time-and-tags :datetime="item.videoList.created" :tag="item.videoList.category" class="time-ago" spacing/>
    </v-card-subtitle>

    <v-card-title :style="'width:' + titleWidth" class="pt-2 pb-5 name text-wrap">{{
        item.videoList.name
      }}
    </v-card-title>

    <v-card-text style="position: absolute; bottom: 0;">
      <v-icon :color="$finColors.primaryDark">icon-eye</v-icon>
      {{ item.videoList.views }}
      <v-icon :color="$finColors.primaryDark" class="ml-5">icon-likes</v-icon>
      {{ item.videoList.votes }}
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "fin-video-item",
  props: {
    /** The video item to display */
    item: {
      type: Object,
      default: null
    },
    /** The height of the v-card, set by VideoScroller component */
    itemHeight: {
      type: Number
    }
  },
  data() {
    return {
      titleWidth: ''
    }
  },
  methods: {
    calculateTitleWidth() {
      this.titleWidth = this.$refs.card.$el.clientWidth + 'px'
    }
  }
}
</script>

<style lang="scss" scoped>

.time-ago ::v-deep .tag {
  padding: 3px 8px;
  border: solid 1px $fin-color-light-blue-gray;
  background-color: $fin-color-pale-grey;

  font-family: $body-font-family;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}

.name {
  font-family: $body-font-family;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
  /* additional */
  word-break: break-word !important;
}
</style>
